import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";

import "hammerjs";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ToastrModule } from "ngx-toastr"; // For auth after login toast

import { CoreModule } from "@core/core.module";
import { CoreCommonModule } from "@core/common.module";
import { CoreSidebarModule, CoreThemeCustomizerModule } from "@core/components";

import { coreConfig } from "app/app-config";

import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { SampleModule } from "app/main/sample/sample.module";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AdsComponent } from "./main/ganatak-dashboard/wajad/ads/ads.component";
import { AddAdsComponent } from "./main/ganatak-dashboard/add-pages/add-ads/add-ads.component";
import { CounselorsComponent } from "./main/ganatak-dashboard/wajad/counselors/counselors.component";
import { AddCounselorsComponent } from "./main/ganatak-dashboard/add-pages/add-counselors/add-counselors.component";
import { StoresOffersComponent } from "./main/ganatak-dashboard/wajad/stores-offers/stores-offers.component";
import { AddStoresOffersComponent } from "./main/ganatak-dashboard/add-pages/add-stores-offers/add-stores-offers.component";
import { CancelationReasonComponent } from "./main/ganatak-dashboard/wajad/cancelation-reason/cancelation-reason.component";
import { AddCancelationReasonComponent } from "./main/ganatak-dashboard/add-pages/add-cancelation-reason/add-cancelation-reason.component";
import { CompaniesComponent } from "./main/ganatak-dashboard/wajad/companies/companies.component";
import { AddCompaniesComponent } from "./main/ganatak-dashboard/add-pages/add-companies/add-companies.component";
import { ConsultingComponent } from "./main/ganatak-dashboard/wajad/consulting/consulting.component";
import { AddConsultingComponent } from "./main/ganatak-dashboard/add-pages/add-consulting/add-consulting.component";
import { CategoriesComponent } from "./main/ganatak-dashboard/wajad/categories/categories.component";
import { AddCategpriesComponent } from "./main/ganatak-dashboard/add-pages/add-categpries/add-categpries.component";
import { ServicesComponent } from "./main/ganatak-dashboard/wajad/services/services.component";
import { AddServicesComponent } from "./main/ganatak-dashboard/add-pages/add-services/add-services.component";
import { TagsComponent } from "./main/ganatak-dashboard/wajad/tags/tags.component";
import { AddTagsComponent } from "./main/ganatak-dashboard/add-pages/add-tags/add-tags.component";
import { ArticlesComponent } from "./main/maktbity/articles/articles.component";
import { AddArticlesComponent } from "./main/ganatak-dashboard/add-pages/add-articles/add-articles.component";
import { OffersComponent } from "./main/ganatak-dashboard/wajad/offers/offers.component";
import { AddOffersComponent } from "./main/ganatak-dashboard/add-pages/add-offers/add-offers.component";
import { AddLanguagePlantcardsComponent } from "./main/ganatak-dashboard/add-pages/add-language-plantcards/add-language-plantcards.component";
import { AddUsersComponent } from "./main/ganatak-dashboard/add-pages/add-users/add-users.component";
import { UsersComponent } from "./main/maktbity/users/users.component";
import { PlantCardsComponent } from "./main/ganatak-dashboard/wajad/plant-cards/plant-cards.component";
import { SettingsDetailsComponent } from "./main/ganatak-dashboard/wajad/settings-details/settings-details.component";
import { TermsConditionsComponent } from "./main/ganatak-dashboard/wajad/terms-conditions/terms-conditions.component";
import { NotificationsComponent } from "./main/ganatak-dashboard/wajad/notifications/notifications.component";
import { AboutComponent } from "./main/ganatak-dashboard/wajad/about/about.component";
import { CurrenciesComponent } from "./main/ganatak-dashboard/wajad/currencies/currencies.component";
import { CountriesComponent } from "./main/ganatak-dashboard/wajad/countries/countries.component";
import { CitiesComponent } from "./main/ganatak-dashboard/wajad/cities/cities.component";
import { LanguagePlansComponent } from "./main/ganatak-dashboard/wajad/language-plans/language-plans.component";
import { OpenScreensComponent } from "./main/maktbity/open-screens/open-screens.component";
import { LanguageLightComponent } from "./main/ganatak-dashboard/wajad/language-light/language-light.component";
import { GanatakCommunityComponent } from "./main/ganatak-dashboard/wajad/ganatak-community/ganatak-community.component";
import { LanguageRootComponent } from "./main/ganatak-dashboard/wajad/language-root/language-root.component";
import { LanguageSeedComponent } from "./main/ganatak-dashboard/wajad/language-seed/language-seed.component";
import { LanguageSoilComponent } from "./main/ganatak-dashboard/wajad/language-soil/language-soil.component";
import { LanguageStemComponent } from "./main/ganatak-dashboard/wajad/language-stem/language-stem.component";
import { PaperformComponent } from "./main/ganatak-dashboard/wajad/paperform/paperform.component";
import { SizesComponent } from "./main/ganatak-dashboard/wajad/sizes/sizes.component";
import { LanguageCounselorspaymentComponent } from "./main/ganatak-dashboard/wajad/language-counselorspayment/language-counselorspayment.component";
import { SlidersComponent } from "./main/ganatak-dashboard/wajad/sliders/sliders.component";
import { AddCurrenciesComponent } from "./main/ganatak-dashboard/add-pages/add-currencies/add-currencies.component";
import { AddCountriesComponent } from "./main/ganatak-dashboard/add-pages/add-countries/add-countries.component";
import { AddCitiesComponent } from "./main/ganatak-dashboard/add-pages/add-cities/add-cities.component";
import { AddLanguagePlansComponent } from "./main/ganatak-dashboard/add-pages/add-language-plans/add-language-plans.component";
import { AddOpenScreensComponent } from "./main/maktbity/add-open-screens/add-open-screens.component";
import { AddLanguageLightComponent } from "./main/ganatak-dashboard/add-pages/add-language-light/add-language-light.component";
import { AddGanatakCommunityComponent } from "./main/ganatak-dashboard/add-pages/add-ganatak-community/add-ganatak-community.component";
import { AddLanguageRootComponent } from "./main/ganatak-dashboard/add-pages/add-language-root/add-language-root.component";
import { AddLanguageSeedComponent } from "./main/ganatak-dashboard/add-pages/add-language-seed/add-language-seed.component";
import { AddLanguageSoilComponent } from "./main/ganatak-dashboard/add-pages/add-language-soil/add-language-soil.component";
import { AddLanguageStemComponent } from "./main/ganatak-dashboard/add-pages/add-language-stem/add-language-stem.component";
import { AddPaperformComponent } from "./main/ganatak-dashboard/add-pages/add-paperform/add-paperform.component";
import { AddSizesComponent } from "./main/ganatak-dashboard/add-pages/add-sizes/add-sizes.component";
import { AddLanguageCounselorspaymentComponent } from "./main/ganatak-dashboard/add-pages/add-language-counselorspayment/add-language-counselorspayment.component";
import { AddSlidersComponent } from "./main/ganatak-dashboard/add-pages/add-sliders/add-sliders.component";
import { VouchersComponent } from "./main/ganatak-dashboard/wajad/vouchers/vouchers.component";
import { SignInComponent } from "./main/sign-in/sign-in.component";
import { CommonModule } from "@angular/common";
import { AuthGuard, JwtInterceptor } from "./auth/helpers";
import { HomeComponent } from "./main/maktbity/home/home.component";
import { DailyUsersComponent } from "./main/maktbity/daily-users/daily-users.component";
import { BooksComponent } from "./main/maktbity/books/books.component";
import { AddNewBookComponent } from "./main/maktbity/add-new-book/add-new-book.component";
import { MostViewBooksComponent } from "./main/maktbity/most-view-books/most-view-books.component";
import { MainCategoriesComponent } from "./main/maktbity/main-categories/main-categories.component";
import { MainCategoriesAddBookComponent } from "./main/maktbity/main-categories-add-book/main-categories-add-book.component";
import { SubCategoriesComponent } from "./main/maktbity/sub-categories/sub-categories.component";
import { FakeUsersComponent } from "./main/maktbity/fake-users/fake-users.component";
import { AddFakeUsersComponent } from "./main/maktbity/add-fake-users/add-fake-users.component";
import { LoadingScreenComponent } from "./main/maktbity/loading-screen/loading-screen.component";
import { EditFakeUserComponent } from "./main/maktbity/edit-fake-user/edit-fake-user.component";
import { AddSubcategoriesComponent } from "./main/maktbity/add-subcategories/add-subcategories.component";
import { PaginationComponent } from "./main/maktbity/pagination/pagination.component";
import { EditUserComponent } from "./main/maktbity/edit-user/edit-user.component";
import { EditBookComponent } from "./main/maktbity/books/edit-book/edit-book.component";
import { ArticlesDetailsComponent } from "./main/maktbity/articles/articles-details/articles-details.component";
import { UserFollowersComponent } from "./main/maktbity/users/user-followers/user-followers.component";
import { UserFollowingComponent } from "./main/maktbity/users/user-following/user-following.component";
import { UserArticlesComponent } from "./main/maktbity/users/user-articles/user-articles.component";
import { ReportsComponent } from "./main/maktbity/reports/reports.component";
import { SendNotificationComponent } from "./main/maktbity/users/send-notification/send-notification.component";
import { AddStoreBookComponent } from "./main/maktbity/add-store-book/add-store-book.component";
import { EditLinksComponent } from "./main/maktbity/books/edit-links/edit-links.component";
import { EditReportsComponent } from "./main/maktbity/reports/edit-reports/edit-reports.component";
import { EditReportsLinksComponent } from "./main/maktbity/reports/edit-reports-links/edit-reports-links.component";
import { EmailClickComponent } from "./main/maktbity/email-click/email-click.component";
import { MobilePageComponent } from "./main/maktbity/mobile-page/mobile-page.component";
import { AddMobilePageComponent } from "./main/maktbity/mobile-page/add-mobile-page/add-mobile-page.component";
import { SocialLinksComponent } from "./main/maktbity/social-links/social-links.component";
import { AddSocialLinksComponent } from "./main/maktbity/add-social-links/add-social-links.component";
import { EditSocialLinksComponent } from "./main/maktbity/edit-social-links/edit-social-links.component";
import { EditMostViewBookComponent } from "./main/maktbity/books/edit-most-view-book/edit-most-view-book.component";
import { NewPaginationComponent } from "./main/maktbity/pagination/new-pagination/new-pagination.component";
import { AskBookComponent } from "./main/maktbity/ask-book/ask-book.component";
import { EditOpenScreenComponent } from "./main/maktbity/open-screens/edit-open-screen/edit-open-screen.component";
import { ChatsComponent } from "./main/maktbity/chats/chats.component";
import { ChatViewComponent } from "./main/maktbity/chat-view/chat-view.component";
import { ContestsComponent } from "./main/maktbity/contests/contests.component";
import { ContestEntryReviewComponent } from "./main/maktbity/contests/contest-entry-review/contest-entry-review.component";
import { StoriesComponent } from "./main/maktbity/stories/stories.component";
import { StoryEditComponent } from "./main/maktbity/stories/story-edit/story-edit.component";
import { StoryDetailsComponent } from "./main/maktbity/stories/story-details/story-details.component";
import { WritersComponent } from "./main/maktbity/writers/writers.component";
import { MonetizationTermsComponent } from "./main/maktbity/monetization-terms/monetization-terms.component";
import { MonetizationRequestsComponent } from "./main/maktbity/monetization-requests/monetization-requests.component";


const appRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
    data: { animation: "sample" },
    canActivate: [AuthGuard],
  },
  {
    path: "home",
    component: HomeComponent,
    data: { animation: "sample" },
  },
  {
    path: "users",
    component: UsersComponent,
    data: { animation: "sample" },
  },
  {
    path: "daily-users",
    component: DailyUsersComponent,
    data: { animation: "sample" },
  },
  {
    path: "book",
    component: BooksComponent,
    data: { animation: "sample" },
  },
  {
    path: "mobile",
    component: MobilePageComponent,
    data: { animation: "sample" },
  },
  {
    path: "email-click",
    component: EmailClickComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-book",
    component: AddNewBookComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-book-store",
    component: AddStoreBookComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-book/:id",
    component: EditBookComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-reports/:id",
    component: EditReportsComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-reports-links/:id",
    component: EditReportsLinksComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-links/:id",
    component: EditLinksComponent,
    data: { animation: "sample" },
  },
  {
    path: "most-view-books",
    component: MostViewBooksComponent,
    data: { animation: "sample" },
  },
  {
    path: "articles",
    component: ArticlesComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-article",
    component: AddArticlesComponent,
    data: { animation: "sample" },
  },
  {
    path: "main-categories",
    component: MainCategoriesComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-new-book-main",
    component: MainCategoriesAddBookComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-new-book-mainn/:id",
    component: AddNewBookComponent,
    data: { animation: "sample" },
  },
  {
    path: "sub-cat",
    component: SubCategoriesComponent,
    data: { animation: "sample" },
  },
  {
    path: "reports",
    component: ReportsComponent,
    data: { animation: "sample" },
  },
  {
    path: "ask-books",
    component: AskBookComponent,
    data: { animation: "sample" },
  },

  {
    path: "social-links",
    component: SocialLinksComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-social-links",
    component: AddSocialLinksComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-social-links/:id",
    component: EditSocialLinksComponent,
    data: { animation: "sample" },
  },

  {
    path: "open-screen",
    component: OpenScreensComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-open-screen",
    component: AddOpenScreensComponent,
    data: { animation: "sample" },
  },
  {
    path: "fake-user",
    component: FakeUsersComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-fake-user",
    component: AddFakeUsersComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-fake-user/:id",
    component: AddFakeUsersComponent,
    data: { animation: "sample" },
  },
  {
    path: "add-fake-user/:id",
    component: AddFakeUsersComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-fake-user/:id",
    component: EditFakeUserComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-most-view-book/:id",
    component: EditMostViewBookComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-user/:id",
    component: EditUserComponent,
    data: { animation: "sample" },
  },
  {
    path: "edit-open-screen/:id",
    component: EditOpenScreenComponent,
    data: { animation: "sample" },
  },
  {
    path: "article-details/:id",
    component: ArticlesDetailsComponent,
    data: { animation: "sample" },
  },
  {
    path: "user-following/:id",
    component: UserFollowingComponent,
    data: { animation: "sample" },
  },
  {
    path: "send-notification/:id",
    component: SendNotificationComponent,
    data: { animation: "sample" },
  },
  {
    path: "user-followers/:id",
    component: UserFollowersComponent,
    data: { animation: "sample" },
  },
  {
    path: "user-articles/:id",
    component: UserArticlesComponent,
    data: { animation: "sample" },
  },
  {
    path: "pages",
    loadChildren: () =>
      import("./main/pages/pages.module").then((m) => m.PagesModule),
  },

  {
    path: "chats",
    component: ChatsComponent,
    data: { animation: "sample" },
  },
  {
    path: "chat-view",
    component: ChatViewComponent,
    data: { isView: true },
  },
  {
    path: "contests",
    component: ContestsComponent,
    data: { animation: "sample" },
  },
  {
    path: "contests/entries/:id",
    component: ContestEntryReviewComponent,
    data: { animation: "sample" },
  },
  {
    path: "stories",
    component: StoriesComponent,
    data: { animation: "sample" },
  },
  {
    path: "stories/details/:id",
    component: StoryDetailsComponent,
    data: { animation: "sample" },
    canActivate: [AuthGuard],
  },
  {
    path: "stories/edit/:id",
    component: StoryEditComponent,
    data: { animation: "sample" },
    canActivate: [AuthGuard],
  },

  {
    path: "writers",
    component: WritersComponent,
    data: { animation: "sample" },
  },
  {
    path: "monetization-terms",
    component: MonetizationTermsComponent,
    data: { animation: "sample" },
    canActivate: [AuthGuard],
  },
  {
    path: "monetization-requests",
    component: MonetizationRequestsComponent,
    data: { animation: "sample" },
    canActivate: [AuthGuard],
  },
  {
    path: "",
    redirectTo: "/home",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "/pages/miscellaneous/error", //Error 404 - Page not found
  },
];

@NgModule({
  declarations: [
    AppComponent,
    AdsComponent,
    AddAdsComponent,
    CounselorsComponent,
    AddCounselorsComponent,
    StoresOffersComponent,
    AddStoresOffersComponent,
    CancelationReasonComponent,
    AddCancelationReasonComponent,
    CompaniesComponent,
    AddCompaniesComponent,
    ConsultingComponent,
    AddConsultingComponent,
    CategoriesComponent,
    AddCategpriesComponent,
    ServicesComponent,
    AddServicesComponent,
    TagsComponent,
    AddTagsComponent,
    ArticlesComponent,
    AddArticlesComponent,
    OffersComponent,
    AddOffersComponent,
    AddLanguagePlantcardsComponent,
    AddUsersComponent,
    UsersComponent,
    PlantCardsComponent,
    SettingsDetailsComponent,
    TermsConditionsComponent,
    NotificationsComponent,
    AboutComponent,
    PaginationComponent,
    CurrenciesComponent,
    CountriesComponent,
    CitiesComponent,
    LanguagePlansComponent,
    OpenScreensComponent,
    LanguageLightComponent,
    GanatakCommunityComponent,
    LanguageRootComponent,
    LanguageSeedComponent,
    LanguageSoilComponent,
    LanguageStemComponent,
    PaperformComponent,
    SizesComponent,
    LanguageCounselorspaymentComponent,
    SlidersComponent,
    AddCurrenciesComponent,
    AddCountriesComponent,
    AddCitiesComponent,
    AddLanguagePlansComponent,
    AddOpenScreensComponent,
    AddLanguageLightComponent,
    AddGanatakCommunityComponent,
    AddLanguageRootComponent,
    AddLanguageSeedComponent,
    AddLanguageSoilComponent,
    AddLanguageStemComponent,
    AddPaperformComponent,
    AddSizesComponent,
    AddCounselorsComponent,
    AddLanguageCounselorspaymentComponent,
    AddSizesComponent,
    AddCounselorsComponent,
    AddSlidersComponent,
    VouchersComponent,
    AddCounselorsComponent,
    SignInComponent,
    HomeComponent,
    DailyUsersComponent,
    BooksComponent,
    AddNewBookComponent,
    MostViewBooksComponent,
    MainCategoriesComponent,
    MainCategoriesAddBookComponent,
    SubCategoriesComponent,
    FakeUsersComponent,
    AddFakeUsersComponent,
    LoadingScreenComponent,
    EditFakeUserComponent,
    AddSubcategoriesComponent,
    PaginationComponent,
    EditUserComponent,
    EditBookComponent,
    ArticlesDetailsComponent,
    UserFollowersComponent,
    UserFollowingComponent,
    UserArticlesComponent,
    ReportsComponent,
    SendNotificationComponent,
    AddStoreBookComponent,
    EditLinksComponent,
    EditReportsComponent,
    EditReportsLinksComponent,
    EmailClickComponent,
    MobilePageComponent,
    AddMobilePageComponent,
    SocialLinksComponent,
    AddSocialLinksComponent,
    EditSocialLinksComponent,
    EditMostViewBookComponent,
    NewPaginationComponent,
    AskBookComponent,
    EditOpenScreenComponent,
    ChatsComponent,
    ChatViewComponent,
    ContestsComponent,
    ContestEntryReviewComponent,
    StoriesComponent,
    StoryEditComponent,
    StoryDetailsComponent,
    WritersComponent,
    MonetizationTermsComponent,
    MonetizationRequestsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: "enabled", // Add options right here
      relativeLinkResolution: "legacy",
    }),
    TranslateModule.forRoot(),

    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,

    // App modules
    LayoutModule,
    SampleModule,
    NgxDatatableModule,
    FormsModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
  ],

  bootstrap: [AppComponent],
  exports: [
    PaginationComponent, // <--- important
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
})
export class AppModule {}
